import { splitExpense } from '../../utils/expenseMoney'

function money(n) {
    return (Number(n) || 0).toLocaleString('en-CA', { style: 'currency', currency: 'CAD' })
}

/**
 * "Bought a car wash too" on a fuel receipt.
 *
 * The line stays one entry with one receipt, but the wash is not fuel: the
 * report files it under its own category (Vehicle Repair & Maintenance) and the
 * rest under Fuel. The wash is asked for BEFORE tax because that is the figure
 * printed beside it on a pump receipt; the tax on it is worked out from there.
 *
 * value/onChange carry the whole line, so the breakdown can use the amount paid
 * and the HST box alongside the wash.
 */
export default function CarWashField({ value, onChange, taxRate, filedUnder, mainLabel = 'Fuel' }) {
    const set = (key, v) => onChange({ ...value, [key]: v })

    const split = value.carWash
        ? splitExpense({ ...value, tipAmount: 0, carWashAmount: value.carWashAmount, taxRate })
        : null

    return (
        <div>
            <label className="flex items-center gap-2 text-sm font-medium text-gray-700">
                <input
                    type="checkbox"
                    className="w-4 h-4"
                    style={{ width: 'auto' }}
                    checked={value.carWash === true}
                    onChange={e => onChange({
                        ...value,
                        carWash: e.target.checked,
                        // Unticking forgets the price, so ticking again starts clean.
                        carWashAmount: e.target.checked ? value.carWashAmount : '',
                    })}
                />
                Car wash on this receipt too
            </label>

            {value.carWash && (
                <div className="mt-2">
                    <label className="form-label">Car wash price before tax</label>
                    <input
                        type="number"
                        step="0.01"
                        min="0"
                        inputMode="decimal"
                        value={value.carWashAmount}
                        onChange={e => set('carWashAmount', e.target.value)}
                        placeholder="12.99"
                    />
                    <p className="text-xs text-gray-500 mt-1">
                        As printed beside the wash on the receipt. The amount paid above stays the whole
                        receipt — the wash is filed under {filedUnder} and the rest as {mainLabel.toLowerCase()}.
                    </p>

                    {split && split.paid > 0 && split.washPreTax > 0 && (
                        <div className="mt-3 p-3 bg-gray-50 rounded-lg text-sm space-y-1">
                            <div className="flex justify-between text-gray-600">
                                <span>{mainLabel}</span>
                                <span>{money(split.mainPaid)}</span>
                            </div>
                            <div className="flex justify-between text-gray-600">
                                <span>
                                    Car wash {money(split.washPreTax)}
                                    {split.washTax > 0 && ` + ${money(split.washTax)} HST`}
                                </span>
                                <span>{money(split.washPaid)}</span>
                            </div>
                            <div className="flex justify-between font-semibold text-gray-900 pt-1 border-t">
                                <span>Charged to the card</span>
                                <span>{money(split.paid)}</span>
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div>
    )
}
